import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelection,
  setSelectionFor,
  clearBooking,
  setBooking,
} from "redux/slices/booking";

import useAPI from "hooks/useAPI";

const useBookings = () => {
  // const booking = useSelector((state) => state.booking);
  const dispatch = useDispatch();
  const { API } = useAPI({});
  const getBookingById = async (bookingId) => {
    let data = await API.get(`/bookings/${bookingId}`);
    return data?.booking;
  };
  const getAndSetSelectionByBookingId = async (bookingId) => {
    if (!bookingId) {
      return console.error("No booking id passed", bookingId);
    }

    try {
      let booking = await getBookingById(bookingId);
      if (booking) {
        // dispatch(setSelection({ ...booking.selection, bookingId }));
        dispatch(setBooking(booking));
      } else {
        console.error("No booking", bookingId);
        dispatch(clearBooking());
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const bookingHasBeenPaid = (booking) => {
    console.log("bookingHasBeenPaid check", booking);
    if (!booking) {
      console.error("No booking to check hasBeenPaid");
      return false;
    }
    let hasBeenPaid = booking?.stripe?.paymentIntent?.status === "succeeded";

    let isFree = booking?.cost?.total === 0;

    console.log("hasBeenPaid", hasBeenPaid, "isFree", isFree);
    return hasBeenPaid || isFree;
  };

  const getCost = async (bookingId) => {
    let data = await API.get(`/bookings/${bookingId}/cost`);
    console.log("data", data, data.cost);
    return data?.cost;
  };

  return {
    getAndSetSelectionByBookingId,
    bookingHasBeenPaid,
    getCost,
  };
};

export default useBookings;
